<template>
  <b-card :key="refrescar">
    <validation-observer ref="cambiarClaveValidation">
      <!-- form -->
      <b-form @submit.prevent>
        <b-row>
          <!-- old password -->
          <b-col md="12">
            <b-form-group
              label-for="account-old-password"
            >
              <label>Contraseña anterior: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Contraseña anterior"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                      <b-form-input
                        id="account-old-password"
                        v-model="passwordValueOld"
                        name="old-password"
                        :type="passwordFieldTypeOld"
                        placeholder="Ingrese su contraseña anterior"
                        :state="errors.length > 0 ? false:null"
                      />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIconOld"
                        class="cursor-pointer"
                        @click="togglePasswordOld"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ old password -->
        </b-row>
        <b-row>
          <!-- new password -->
          <b-col md="12">
            <b-form-group
              label-for="account-new-password"
            >
              <label>Contraseña nueva: <span class="text-danger">*</span></label>
              <validation-provider
                #default="{ errors }"
                name="Contraseña nueva"
                rules="required"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="account-new-password"
                    v-model="newPasswordValue"
                    :type="passwordFieldTypeNew"
                    name="new-password"
                    placeholder="Ingrese su nueva contraseña"
                    :state="errors.length > 0 ? false:null"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconNew"
                      class="cursor-pointer"
                      @click="togglePasswordNew"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ new password -->

          <!-- retype password -->
          <b-col md="12">
            <b-form-group
              label-for="account-retype-new-password"
            >
              <label>Confirmar contraseña: <span class="text-danger">*</span></label>
              <validation-provider
                #default="{ errors }"
                name="Confirmar contraseña"
                rules="required"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="account-retype-new-password"
                    v-model="RetypePassword"
                    :type="passwordFieldTypeRetype"
                    name="retype-password"
                    placeholder="Confirme su nueva contraseña"
                    :state="errors.length > 0 ? false:null"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconRetype"
                      class="cursor-pointer"
                      @click="togglePasswordRetype"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ retype password -->

          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1 btn-guardar"
              @click="validationForm"
            >
              Guardar
            </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'

import Ripple from 'vue-ripple-directive'
import actions from "@/assets/utils/utils";
import axios from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

localize({
  es,
})

localize('es')

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      refrescar: 1,
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    validationForm() {
      this.$refs.cambiarClaveValidation.validate().then(success => {
        if (success) {
          this.cambiarClave()
        }
      })
    },
    cambiarClave(){
      actions.bloquearBoton()
      axios.post('api', {
        query: `mutation cambiarClave($anteriorClave: String!, $nuevaClave: String!, $confirmarClave: String!){
                    cambiarClave(anteriorClave:$anteriorClave, nuevaClave:$nuevaClave, confirmarClave:$confirmarClave)
                    {
                        status,
                        message,
                    }
                }`,
        variables: {
          anteriorClave: this.passwordValueOld,
          nuevaClave: this.newPasswordValue,
          confirmarClave: this.RetypePassword,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.cambiarClave.status === 'success') {
            this.showToast(response.data.data.cambiarClave.message)
            this.passwordValueOld = ''
            this.newPasswordValue = ''
            this.RetypePassword = ''
            this.refrescar += 1
          } else {
            this.$swal({
              title: 'Error',
              text: response.data.data.cambiarClave.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
        actions.desbloquearBoton()
      })
    },
    showToast(mensaje) {
      this.$toast.success({
        component: ToastificationContent,
        props: {
          title: 'Cambio de contraseña',
          icon: 'InfoIcon',
          text: mensaje,
        },
      },
      {
        position: 'bottom-right',
      })
    },
  },
}
</script>
